import { ProductModel } from './../models/product.model';
import {Component, EventEmitter, Input, Output, OnChanges} from '@angular/core';
import { ModelModel } from '../models/model.model';


@Component({
  selector: 'app-model-details-related-products',
  template: `
    <div class="d-none d-lg-block col-lg-3 col-xl-3" *ngFor="let product of this.relatedProducts">
      <app-product-card [model]="product" [productLine]="this.productLine" [showFamily]="false" [productClass]="this.productClass" [origprodId]="this.origProduct.id" [productModelId]="this.model.id" (selected)="this.selected($event)"></app-product-card>
    </div>
    <div class="d-none d-lg-block col-lg-12 col-xl-12" style="width:100%;text-align:center;" *ngIf="this.showViewMore"><button class="viewMoreButton" (click)="viewMore()">{{viewMoreText}}</button></div>
    <div style="margin: 0 auto" class="d-lg-none d-xl-none">
      <app-carousel [model]="this.relatedProducts" [productLine]="this.productLine" [showFamily]="false" [origprodId]="this.origProduct.id" [productModelId]="this.model.id" (selected)="this.selected($event)"></app-carousel>
    </div>
  `,
  styles: [
    `
    .viewMoreButton {
      border: 1px solid #A50034;	
      border-radius: 4px;	
      background-color: #FFFFFF;
      color: #A50034;	
      font-family: 'LGEIRegular';	
      font-size: 16px;	
      line-height: 2;	
      text-align: center;
      width: 150px;
      cursor: pointer;
    }

    .flex-row {
      display: flex;
      flex-wrap: wrap;
      padding-left: 15px;
      padding-right: 15px;
    }
    .flex-row > [class*='col-'] {
      display: flex;
      flex-direction: column;
    }
    
    .flex-row .thumbnail,
    .flex-row .caption {
      flex-direction: column;
      display: flex;
      flex: 1 0 auto;
      height: auto;
      position: relative;
    }
    .flex-text {
      flex-grow: 1;
    }
    .flex-row img {
      min-width: 0;
      width: 100%;
    }

    @media only screen and (max-width : 480px){
      .flex-row > [class*='col-'] {
          width: 100%;
      }
      .flex-row  {
        padding-left: 0px;
        padding-right: 0px;
      }

    }

    @media only screen and (max-width : 768px){
      .height-responsive {
          height: 450px;
      }
    }
  `
  ]
})
export class ModelDetailsRelatedProductsComponent implements OnChanges {
  @Input() model: ModelModel;
  @Input() origProduct: ProductModel;
  @Input() productLine: string;
  @Input() iscommercial: string;
  @Input() productClass: string = null;
  relatedProducts: ProductModel[] = [];
  viewMoreToggle: Boolean = true;
  viewMoreText = 'View More';
  showViewMore = false;

  ngOnChanges(){
      let numDisplayed = 0;
      for(let i=0;i<this.model.relatedAccessories.length && numDisplayed < 5;i++)
      {
        if (this.model.relatedAccessories[i].shouldDisplay(this.iscommercial, this.productClass)) {
          this.relatedProducts.push(this.model.relatedAccessories[i]);
          numDisplayed++;
        }
      }
      this.showViewMore = numDisplayed >=4;
    }

  viewMore(){
    this.relatedProducts = [];
    if (this.viewMoreToggle === true){
      for(let i=0;i<this.model.relatedAccessories.length;i++)
      {
        this.relatedProducts.push(this.model.relatedAccessories[i]);
      }
      this.viewMoreToggle = false;
      this.viewMoreText = 'View Less';
    } else {
      let numDisplayed = 0;
      for(let i=0;i<this.model.relatedAccessories.length && numDisplayed < 5;i++)
      {
        if (this.model.relatedAccessories[i].shouldDisplay(this.iscommercial, this.productClass)) {
          this.relatedProducts.push(this.model.relatedAccessories[i]);
          numDisplayed++;
        }
      }
      this.viewMoreToggle = true;
      this.viewMoreText = 'View More';
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/product-category/components/model-details-related-products.component.ts